export const maxAttachmentCount = 20;
